/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *//*
  ... (existing code above this line) ...
*/
// Listen for the specific event when an item is successfully added to the cart via AJAX
document.addEventListener('shopify:section:load', function() {
    if (window.Shopify && window.Shopify.onCartAtc) {
        window.Shopify.onCartAtc(function(cart) {
            // Redirect immediately after confirmation
            window.location.href = '/checkout';
        });
    } else {
        // Fallback for themes that don't support shopify:section:load event structure
        document.addEventListener('DOMContentLoaded', function() {
            const addToCartForm = document.querySelector('form[action="/cart/add"]');
            if (addToCartForm) {
                addToCartForm.addEventListener('submit', function() {
                    setTimeout(function() {
                        window.location.href = '/checkout';
                    }, 500); // 500ms delay
                });
            }
        });
    }
});
